import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageService } from '../../shared/services/storage.service';
import { ApiResponse } from '../shared/classes/api';
import { ConfigurationClient } from '../shared/classes/configuration-client';
import { ApiService } from './api.service';

@Injectable()
export class ConfigurationClientService {

  constructor(private apiService: ApiService, private storageService: StorageService) { }

  update(configurationClient: ConfigurationClient): Observable<ApiResponse> {
    this.storageService.clearCache();
    return this.apiService.post('configuration-client-update/', configurationClient);
  }

  getConfiguration(): Observable<ApiResponse> {
    return this.apiService.get('configuration-client');
}
}
